import { render, staticRenderFns } from "./prats-and-symington.vue?vue&type=template&id=f1c69674&scoped=true"
import script from "./prats-and-symington.vue?vue&type=script&lang=js"
export * from "./prats-and-symington.vue?vue&type=script&lang=js"
import style0 from "./prats-and-symington.vue?vue&type=style&index=0&id=f1c69674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c69674",
  null
  
)

export default component.exports